import { Reveal, Chapter } from "./Reveal";
import { Eye, Brain, Heart, MousePointerClick, ArrowRight, ArrowDown } from "lucide-react";

const SEQUENCE = [
  { icon: Eye, text: "Cilvēkam vispirms ir jāpamana Jūsu baneris vai video." },
  { icon: Brain, text: "Tad dažu sekunžu laikā jāsaprot piedāvājums." },
  { icon: Heart, text: "Jāierauga iemesls, kāpēc tas viņam ir aktuāls." },
  { icon: MousePointerClick, text: "Un visbeidzot - jārodas motivācijai rīkoties." },
];

const PARADOXES = [
  ["Baneris var būt skaists,", "bet nepamanāms."],
  ["Video var būt profesionāli nofilmēts,", "bet pirmās sekundes var neieinteresēt."],
  ["Produkts var būt lielisks,", "bet kreatīvs var nepaskaidrot, kāpēc cilvēkam to vajadzētu iegādāties."],
];

export default function Problem() {
  return (
    <section id="problems" data-testid="problem-section" className="bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32">
        <Chapter number="02" label="Problēma" />

        <Reveal>
          <h2 className="font-display font-black tracking-tighter leading-[1.02] text-4xl sm:text-5xl lg:text-6xl text-[#003E75] max-w-5xl" data-testid="problem-heading">
            Jūs varat optimizēt auditoriju, bidding un reklāmas budžetu.{" "}
            <span className="text-[#003E75]/30">Bet ja problēma ir banerī vai video?</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-10 max-w-3xl">
          <p className="text-[#003E75]/60 text-base md:text-lg leading-relaxed">
            Uzņēmumi daudz uzmanības velta auditorijām, bidding stratēģijām, kampaņu struktūrai,
            algoritmiem un budžetam (mēs arī). Taču starp Jūsu piedāvājumu un potenciālo klientu
            atrodas vēl viens kritiski svarīgs elements:
          </p>
          <p className="mt-6 font-display font-black uppercase text-5xl md:text-7xl tracking-tighter text-[#ED1C27]" data-testid="problem-keyword">
            Kreatīvs.
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="problem-sequence">
          {SEQUENCE.map((step, i) => (
            <Reveal key={i} delay={0.1 + i * 0.08} className="relative">
              <div className="h-full bg-white border border-black/15 rounded-sm px-6 py-6 hover:border-[#ED1C27] hover:-translate-y-1 transition-all duration-300" data-testid={`problem-step-${i}`}>
                <div className="flex items-center justify-between">
                  <span className="font-display font-black text-[#003E75]/15 text-3xl">0{i + 1}</span>
                  <step.icon className="h-5 w-5 text-[#ED1C27]" />
                </div>
                <p className="mt-6 text-sm md:text-base text-[#003E75]/75 leading-relaxed">{step.text}</p>
              </div>
              {i < SEQUENCE.length - 1 && (
                <>
                  <ArrowRight className="hidden lg:block absolute top-1/2 -right-3.5 -translate-y-1/2 h-4 w-4 text-[#003E75]/30 z-10" />
                  <ArrowDown className="lg:hidden mx-auto mt-2 h-4 w-4 text-[#003E75]/30" />
                </>
              )}
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="mt-10 max-w-3xl">
          <p className="text-[#003E75]/70 text-base md:text-lg leading-relaxed">
            Ja kaut viens no šiem posmiem nenostrādā, Jūs varat zaudēt daļu pārdošanas potenciāla
            vēl pirms cilvēks nonāk mājaslapā.
          </p>
        </Reveal>

        <div className="mt-20 space-y-6">
          {PARADOXES.map(([a, b], i) => (
            <Reveal key={i} delay={i * 0.08}>
              <p className="font-display font-bold text-2xl md:text-4xl tracking-tight" data-testid={`problem-paradox-${i}`}>
                <span className="text-[#003E75]">{a}</span>{" "}
                <span className="text-[#003E75]/25">{b}</span>
              </p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="mt-20 border-l-4 border-[#ED1C27] pl-8 max-w-3xl">
          <p className="text-[#003E75]/60 text-base md:text-lg leading-relaxed">
            Tāpēc mēs nevērtējam, vai kreatīvs mums subjektīvi “patīk”.{" "}
            <span className="text-[#003E75] font-semibold">
              Mēs vērtējam, cik labi tas ir uzbūvēts, lai palīdzētu sasniegt pārdošanas rezultātu.
            </span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
